module.exports = __webpack_public_path__ + "static/media/react.e9f3d01c.svg";